module.exports = __webpack_public_path__ + "static/media/simonSound2.c3c86e71.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Simon/sounds/simonSound2.mp3
// module id = 87
// module chunks = 0